import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { AdminConsoleUserProfileApi } from '@portal/pkg-api/admin-console'
import { UpdateUserProfileRequest, UserProfileResponse } from '@portal/pkg-api/gen/admin-console'
import { getUserNotificationStore } from '@migrate/stores'
import { UserNotificationType } from '@migrate/stores/UserNotificationStore'
import { data } from '@portal/pkg-api/shared'
import i18next from 'i18next'

const prefix = 'preferences.user.userInfo'

export const UserInfoQueries = {
  userInfo: () => ({
    queryKey: [`${prefix}.userInfo`],
    queryFn: async (): Promise<UserProfileResponse> =>
      data(AdminConsoleUserProfileApi.getUserProfile()),
  }),
}

export function useUserInfo() {
  return useQuery(UserInfoQueries.userInfo())
}

export type SaveProfilePayload = Omit<UpdateUserProfileRequest, 'locale'> & { locale: string }

export function useSaveProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (payload: SaveProfilePayload) =>
      data(
        AdminConsoleUserProfileApi.updateUserProfile({
          ...payload,
          locale: payload.locale || null,
        }),
      ),
    onSuccess: (_result, payload) => {
      void queryClient.invalidateQueries(UserInfoQueries.userInfo())
      getUserNotificationStore().addNotification(UserNotificationType.SUCCESS, 'common.saved')
      if (payload.locale && i18next.language !== payload.locale) {
        void i18next.changeLanguage(payload.locale)
      }
    },
    onError: (err: string) => {
      console.error(`Error saving profile: ${err}`, new Error())
      getUserNotificationStore().addNotification(
        UserNotificationType.ERROR,
        err || 'common.error.request.generic',
      )
    },
  })
}
